var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgNeuro4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 552,
    viewBox: "0 0 1440 552",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_538_3501)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_538_3501",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1440,
    height: 552
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1440 552H0V0H1440V552Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_538_3501)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M653.139 -1069.98C665.76 -1094.54 695.903 -1104.22 720.464 -1091.6L1998.45 -434.856C2023.01 -422.234 2032.69 -392.092 2020.06 -367.531L1546.48 554.03C1533.86 578.587 1503.92 588.368 1479.37 575.753C1365.5 517.268 1056.31 358.439 840.648 247.511C625.49 136.841 315.161 -22.5718 201.005 -81.2067C176.438 -93.8257 166.946 -123.875 179.569 -148.44L653.139 -1069.98Z",
    fill: "#EAF4FF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_538_3501"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 552,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgNeuro4);
export default __webpack_public_path__ + "static/media/bg-neuro4.e5140ea4f139bc87f29373b7e24b629a.svg";
export { ForwardRef as ReactComponent };